const Incrememnt = (props) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" stroke="#292E36" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="12.84" cy="12.84" r="11.84" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M16.3929 13.1361H9.88086" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M13.1358 16.3919V9.87988" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Incrememnt;